// extracted by mini-css-extract-plugin
export var backgroundImage = "_redotech-redo-customer-portal-app-lib-login-page-background-image";
export var backgroundImageWrapper = "_redotech-redo-customer-portal-app-lib-login-page-background-image-wrapper";
export var brand = "_redotech-redo-customer-portal-app-lib-login-page-brand";
export var brandContainer = "_redotech-redo-customer-portal-app-lib-login-page-brand-container";
export var fadeIn = "_redotech-redo-customer-portal-app-lib-login-page-fadeIn";
export var logo = "_redotech-redo-customer-portal-app-lib-login-page-logo";
export var page = "_redotech-redo-customer-portal-app-lib-login-page-page";
export var storeReturn = "_redotech-redo-customer-portal-app-lib-login-page-store-return";
export var storeReturnBlock = "_redotech-redo-customer-portal-app-lib-login-page-store-return-block";